import { render, staticRenderFns } from "./MerchantConnect.vue?vue&type=template&id=dc6b4dd4&scoped=true&"
import script from "./MerchantConnect.vue?vue&type=script&lang=ts&"
export * from "./MerchantConnect.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantConnect.vue?vue&type=style&index=0&id=dc6b4dd4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6b4dd4",
  null
  
)

export default component.exports